import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SpgPageRoutingModule } from './spg-routing.module';

import { SpgPage } from './spg.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SpgPageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [SpgPage],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA]
})
export class SpgPageModule {}
